import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { Router, Route, Switch } from 'react-router-dom';

import './assets/css/material-kit-pro-react.css';

import AdminPortalPage from './views/AdminPortal/AdminPortalPage.js';
import LandingPage from './views/LandingPage/LandingPage.js';
import ClientPortalPage from './views/ClientPortal/ClientPortalPage.js';
import LoginPage from './views/Login/LoginPage.js';
import RegisterPage from './views/Register/RegisterPage.js';

var hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/admin-escritorio" component={AdminPortalPage} />
      <Route path="/portal-cliente" component={ClientPortalPage} />
      <Route path="/cadastro" component={RegisterPage} />
      <Route path="/login" component={LoginPage} />
      <Route exact path="/" component={LandingPage} />
    </Switch>
  </Router>,
  document.getElementById('root')
);
